import styled from "styled-components";

/**
 * §8: one card style for everything — products, issues, previews. 12px radius,
 * 16px padding, 1px border, **no shadow**. Cards in a list sit 16px apart; cards
 * in a grid use the 8px gutter (§7).
 */
const Card = styled.div`
	display: flex;
	flex-direction: column;
	padding: var(--space-4);
	border: var(--border-default);
	border-radius: var(--radius-lg);
	background: var(--color-surface);
	box-shadow: none;
	transition: background-color var(--transition-base), border-color var(--transition-base);
`;

export const InteractiveCard = styled(Card).attrs({ tabIndex: 0 })`
	cursor: pointer;

	&:hover {
		background: var(--color-hover-ground);
		border-color: var(--color-border-strong);
	}
	&:focus-visible {
		outline: var(--focus-ring);
		outline-offset: var(--focus-ring-offset);
	}
`;

export default Card;
